import { FONT_BASE } from '../constants/AppFonts';
import { AddCommasToNumber } from '../utils/Utils';

export class GameHud extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.panels = scene.add.image(0, 0, 'game_graphics', 'gamehud_player_bars').setOrigin(0, 0.5);
    this.profile = scene.add.image(0, 0, 'character_thumbs', 'gamehud_robin').setOrigin(1);

    const displaywidth = this.panels.width + this.profile.width;
    this.profile.x = -displaywidth * 0.5 + this.profile.width;
    this.profile.y = this.panels.height * 0.5 + 10;
    this.panels.x = this.profile.x - 32;

    this.healthMask = scene.add.graphics();
    this.healthMask.x = this.panels.x + 43;
    this.healthMask.y = this.panels.y - 30;

    this.specialMask = scene.add.graphics();
    this.specialMask.x = this.panels.x + 54;
    this.specialMask.y = this.panels.y + 10;

    this.specialPowerAnim = scene.add
      .spine(this.panels.x + 141, this.panels.y + 17, 'power_bar', 'animation', true)
      .setVisible(false);

    this.lives = scene.add.image(0, 0, 'locale_text', 'lives_3');
    this.lives.x = this.profile.x - 110;
    this.lives.y = this.profile.y - 94;

    this.score = scene.add
      .text(this.panels.width * 0.54, -this.panels.height * 0.5, '0', {
        fontFamily: FONT_BASE.REGULAR,
        fontSize: 28,
        fill: '#FFFFFF',
        align: 'right',
      })
      .setOrigin(1);

    this.add([
      this.panels,
      this.profile,
      this.healthMask,
      this.specialMask,
      this.lives,
      this.score,
      this.specialPowerAnim,
    ]);
  }

  setHero(hero) {
    this._hero = hero;
    this.profile.setFrame('gamehud_' + hero.id);
    this._cachedHealth = this._cachedSpecial = null;
    this.update(0);
  }

  setHeroLives(value) {
    this.lives.setFrame('lives_' + Math.max(0, value));
    this.scene.tweens.add({
      targets: this.lives,
      scale: 1.5,
      duration: 100,
      yoyo: true,
    });
  }

  update(delta) {
    if (!this._hero) return;

    if (!this._cachedHealth || this._cachedHealth != this._hero.healthPercent) {
      this._cachedHealth = this._hero.healthPercent;
      const healthWidth = 302 * this._hero.healthPercent;
      this.healthMask.clear();
      this.healthMask.fillStyle(0x002d66);
      this.healthMask.moveTo(294, 0);
      this.healthMask.lineTo(Math.max(0, healthWidth - 8), 0);
      this.healthMask.lineTo(Math.max(8, healthWidth), 25);
      this.healthMask.lineTo(302, 25);
      this.healthMask.fill();
    }
    if (!this._cachedSpecial || this._cachedSpecial != this._hero.specialPercent) {
      this._cachedSpecial = this._hero.specialPercent;
      const specialWidth = 201 * this._hero.specialPercent;
      this.specialMask.clear();
      this.specialMask.fillStyle(0x002d66);
      this.specialMask.moveTo(197, 0);
      this.specialMask.lineTo(Math.max(0, specialWidth - 4), 0);
      this.specialMask.lineTo(Math.max(4, specialWidth), 13);
      this.specialMask.lineTo(201, 13);
      this.specialMask.fill();

      this.specialPowerAnim.visible = this._hero.specialPercent >= 1;
    }
  }

  updateScore(value) {
    if (this.score) this.score.text = AddCommasToNumber(value);
  }

  get displayWidth() {
    return 454;
  }

  get displayHeight() {
    return 128;
  }
}
